import { useI18n } from '../i18n';
import { MUSEUM_CARDS } from '../constants';
import { Reveal } from './Reveal';

/** "A life in trophies": intro + a grid of image cards (hover reveals the copy). */
export const Museum = () => {
  const { t } = useI18n();
  return (
    <section className="sec" id="museu">
      <div className="wrap">
        <Reveal className="sec-head">
          <span className="kicker">{t.museum.kicker}</span>
          <h2>{t.museum.title}</h2>
          <p>{t.museum.intro}</p>
        </Reveal>

        <div className="cards">
          {MUSEUM_CARDS.map((c) => {
            const card = t.museum.cards[c.key];
            return (
              <Reveal key={c.key} className="card" delay={c.delay}>
                <div className="cimg">
                  <img src={c.img} alt="" />
                </div>
                <div className="cbody">
                  <div className="cline" />
                  <h3>{card.title}</h3>
                  <p>{card.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
